// extracted by mini-css-extract-plugin
export default {"backbarComponent":"BackBar_backbarComponent__IVUG2","backbarTitle":"BackBar_backbarTitle__fBA-I","backiconStyle":"BackBar_backiconStyle__-N0j6"};